import './index.css';

import * as Sentry from '@sentry/react';
import { RouterProvider } from '@tanstack/react-router';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { router } from './utils/router';

Sentry.init({
  // The dev server should not report into the real project. `enabled: false` rather than skipping
  // `init` so `captureException` stays a callable no-op in dev.
  enabled: import.meta.env.PROD,
  beforeSend(event) {
    const ua = event.request?.headers?.['User-Agent'] ?? navigator.userAgent;
    if (/HeadlessChrome|Googlebot|bingbot|crawler|spider|Lightpanda/i.test(ua)) {
      return null;
    }
    return event;
  },
  denyUrls: [
    // PostHog/rrweb session recorder — injected by browser extensions, not app code
    /start-recording\.js/,
    // Klaviyo onsite bundle — third-party embed, not app code
    /static\.klaviyo\.com/,
  ],
  dsn: 'https://2a93d897d8b3d6d3c9751654256ee545@o4510144647397376.ingest.us.sentry.io/4510195018432512',
  enableLogs: true,
  environment: import.meta.env.VITE_LIZA_STAGE,
  sendDefaultPii: false,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
